import { createAction, props } from '@ngrx/store';

export const updateFromSSOData = createAction(
    '[AUTH] update from SSO',
    props<{ value: boolean }>(),
);
